"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A billing method result has been successfully set if the response
 * contains a non-null credit card ID. This indicates the card has successfully been
 * updated to that ID.
 */
function isBillingMethodResultSuccessful(billingMethodResult) {
    return billingMethodResult && billingMethodResult.creditCard && !!billingMethodResult.creditCard.id;
}
exports.isBillingMethodResultSuccessful = isBillingMethodResultSuccessful;
//# sourceMappingURL=billing_method_result.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/billing/billing_method_result.js
// module id = bgfy
// module chunks = 20 21